import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type TagsPayloadCamelPlural } from "interfaces/Tags";

export interface TagsSliceState {
  tags: TagsPayloadCamelPlural;
  error?: Error;
}

const initialState: TagsSliceState = {
  tags: {},
  error: undefined,
};

const tagsSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.Scorm}/tags`,
  initialState,
  reducers: {
    fetchTags(state: TagsSliceState, action: PayloadAction<TagsPayloadCamelPlural>) {
      state.tags = action.payload;
    },
    fetchTagsFailure(state: TagsSliceState, action: PayloadAction<Error>) {
      state.error = action.payload;
    },
    resetTags: (state: TagsSliceState) => {
      state.tags = initialState.tags;
    },
  },
});

export const { fetchTags, fetchTagsFailure, resetTags } = tagsSlice.actions;

export default tagsSlice.reducer;
